import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

export default function CartBillDetails() {
  const { products } = useSelector((state) => state.product);
  const [totalValue, setTotalValue] = useState(0);

  useEffect(() => {
    let total = 0;

    for (let i = 0; i < products.length; i++) {
      const product = products[i];
      const price = parseFloat(product.price);
      const quantity = product.totalSelectQuntity
        ? product.totalSelectQuntity
        : 0;
      total += price * quantity;
    }
    setTotalValue(total);
  }, [products]);
  return (
    <>
      {/* <!-- Bill Details --> */}
      <div>
        <div className="billDetailsCard">
          <h4 className="mt-2 mb-8 text-xl font-bold text-center">
            Bill Details
          </h4>
          <div className="space-y-4">
            {/* <!-- sub total --> */}
            <div className="flex items-center justify-between">
              <p>Sub Total</p>
              <p>
                BDT <span className="lws-subtotal">{totalValue}</span>
              </p>
            </div>
            {/* <!-- Discount --> */}
            <div className="flex items-center justify-between">
              <p>Discount</p>
              <p>
                BDT <span className="lws-discount">0</span>
              </p>
            </div>
            {/* <!-- VAT --> */}
            <div className="flex items-center justify-between">
              <p>VAT</p>
              <p>
                BDT <span className="vat">0</span>
              </p>
            </div>
            {/* <!-- Total --> */}
            <div className="flex items-center justify-between pb-4">
              <p className="font-bold">TOTAL</p>
              <p className="font-bold">
                BDT <span className="lws-total">{totalValue}</span>
              </p>
            </div>
            <button className="placeOrderbtn">place order</button>
          </div>
        </div>
      </div>
    </>
  );
}
